// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pr-0";